import { axiosIns } from "../utils";

// Metier Types
export const fetchMetierTypes = async () => {
  const res = await axiosIns.get("/metier-types/");
  return res && res.data ? res.data : res;
};

export const createMetierTypeApi = async (payload) => {
  const res = await axiosIns.post("/metier-types/", payload);
  return res && res.data ? res.data : res;
};

export const updateMetierTypeApi = async (id, payload) => {
  const res = await axiosIns.patch(`/metier-types/${id}/`, payload);
  return res && res.data ? res.data : res;
};

export const deleteMetierTypeApi = async (id) => {
  const res = await axiosIns.delete(`/metier-types/${id}/`);
  return res && res.data ? res.data : res;
};

// Metiers
export const fetchMetiers = async () => {
  const res = await axiosIns.get("/metiers/");
  return res && res.data ? res.data : res;
};

export const createMetierApi = async (payload) => {
  const res = await axiosIns.post("/metiers/", payload);
  return res && res.data ? res.data : res;
};

export const updateMetierApi = async (id, payload) => {
  const res = await axiosIns.patch(`/metiers/${id}/`, payload);
  return res && res.data ? res.data : res;
};

export const deleteMetierApi = async (id) => {
  const res = await axiosIns.delete(`/metiers/${id}/`);
  return res && res.data ? res.data : res;
};

// Pros Metiers (read only)
export const fetchProsMetiers = async () => {
  const res = await axiosIns.get("/pros-metiers/");
  return res && res.data ? res.data : res;
};
